import { Variant } from './utils';
type AnyFunction = (...args: any) => any;
export function memoize(callback: AnyFunction): AnyFunction {
  const results: Record<any, any> = {};

  return (...args: any[]) => {
    const cacheKey = JSON.stringify(args);
    if (!results[cacheKey]) {
      results[cacheKey] = callback(...args);
    }

    return results[cacheKey];
  };
}

export const getVariantsMeta = memoize((selector: string) => {
  const element = document.querySelector(selector);
  if (!(element instanceof HTMLScriptElement)) {
    return {};
  }

  return JSON.parse(element.innerHTML);
});

export function updateVariantDisplayPrice(variant: Variant): void {
  const variantsMeta = getVariantsMeta('#product-variants-meta');
  const currentVariantMeta = variantsMeta[variant.id];
  const salePriceContainer = document.querySelectorAll(
    '[data-price] [data-sale-price]'
  );
  const regularPriceContainer = document.querySelectorAll(
    '[data-price] [data-regular-price]'
  );
  const savingsContainer = document.querySelectorAll(
    '[data-savings-container]'
  );
  const savingsBadge = document.querySelectorAll('.savings-badge');

  if (!salePriceContainer) {
    return;
  }

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  let formatMoney;
  if (typeof window.Shopify.formatMoney === 'function') {
    formatMoney = window.Shopify.formatMoney;
  } else {
    formatMoney = (cents: number, _format: string) => {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: window.Shopify.currency.active,
        maximumFractionDigits: 0,
      }).format(cents / 100);
    };
  }

  salePriceContainer.forEach((container) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    container.innerHTML = `${formatMoney(
      currentVariantMeta.display_price || variant.price,
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      window.theme.moneyFormat
    )}`;
  });

  if (!regularPriceContainer) {
    return;
  }

  if (
    variant.compare_at_price == 0 ||
    !variant.compare_at_price ||
    (variant.compare_at_price == variant.price &&
      !currentVariantMeta.display_price)
  ) {
    regularPriceContainer.forEach((container) => {
      container.classList.add('hidden');
    });
  } else {
    regularPriceContainer.forEach((container) => {
      container.classList.remove('hidden');
    });
  }

  if (!savingsContainer) {
    return;
  }

  const saved =
    variant.compare_at_price -
    (currentVariantMeta.display_price || variant.price);

  if (saved == 0 || !saved) {
    savingsContainer.forEach((container) => {
      container.classList.add('hidden');
    });

    savingsBadge.forEach((container) => {
      container.classList.add('hidden');
    });
  } else {
    savingsContainer.forEach((container) => {
      container.classList.remove('hidden');
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      container.innerHTML = `${formatMoney(
        saved,
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.theme.moneyFormat
      )}`;
    });

    savingsBadge.forEach((container) => {
      container.classList.remove('hidden');
    });
  }
}
